import { SignInForm } from "./SignInForm"
import { SignUpForm } from "./SignUpForm"
import { ForgotPasswordForm } from "./ForgotPasswordForm"
import { ResetPasswordForm } from "./ResetPasswordForm"
import { useParams, useSearchParams } from "react-router-dom"
import LogoCard from "../components/layout/LogoCard"

export default function AuthPage() {
  const { pathname } = useParams<{ pathname: string }>()
  const [searchParams] = useSearchParams()

  const renderForm = () => {
    switch (pathname) {
      case "sign-up":
        // Extract invitation parameters from URL
        const invitationId = searchParams.get("invitation") || undefined
        const prefilledEmail = searchParams.get("email") || undefined

        return <SignUpForm invitationId={invitationId} prefilledEmail={prefilledEmail} />
      case "forgot-password":
        return <ForgotPasswordForm />
      case "reset-password":
        return <ResetPasswordForm />
      default:
        return <SignInForm />
    }
  }

  return <LogoCard>{renderForm()}</LogoCard>
}
